import React from "react";

function Prices() {
  return <div>Prices</div>;
}

export default Prices;
